export default __webpack_public_path__ + "static/media/NamesLandscape.1735c3aa.jpg";